import { actionTypes as at, actionCreators } from '../actions';
import { ActionType } from 'typesafe-actions';
import Types from 'Types';

export const initialState = {
  data: null,
  loading: false,
};

export type Action = ActionType<typeof actionCreators>;

export const reducer = (state = initialState, { type, payload }: Action & Types.StoreAction) => {
  switch (type) {
      case at.LOGIN:
        return {
          data: null,
          loading: true,
        }
      case at.LOGIN_ERROR:
        return {
          ...state,
          loading: false,
          error: payload,
        }
      case at.LOGIN_SUCCESS:
        return {
          ...state,
          loading: false,
          data: payload,
        }
      default:
        return state;
  }
};

export const isLoading = ({ submitForm: { login } }: Types.StoreState) => login.loading;

export const getData = ({ submitForm: { login } }: Types.StoreState) => login.data;

